export default __webpack_public_path__ + "static/media/R_CBANCO_SOL.c0e242a8.pdf";